import { request } from '@/apis/request';
import router from '@/router';
import auth from './auth.vue';
import { useRolesState } from '@/hook/useRoleState';
import logo from '@/assets/images/logo.png'
import * as SDesignIconsVue from '@sdesign/icons-vue'
import bgLBBlueSrc from '@/assets/images/bg-left-bottom.png'
import * as Sentry from '@sentry/vue'
import PartToAI from '@/components/PartToAI/index.vue';
import { IDROUTES_MAP, EXAMIN_MAP } from './const';
import { getText } from './util';
import type { RouteLocationNormalized } from 'vue-router';
import cookie from '@/utils/cookie';

const BASE = `/front`;
const SYSTEM_CODE = 'EOS-QMP-CORE';
const { setRoles, sortRoles, currentRole, setCurrentRole } = useRolesState();

const host = window.location.host
const isSit = host.includes('localhost') || host.includes('sit')
const systemkey = isSit ? '5d9f1cfa7eeef20c6d84f022' : '5d9f143fbc7cf20c91f560e7'
function toCamelCase(str: string): string {
  return str
      .split('-')
      .map((word, index) => {
          // 单词首字母大写
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join('');
}

const lang = localStorage.getItem('lang') || 'zh_CN'

const env = process.env.NODE_ENV;
const settings: Settings = {
  api: {
    baseURL: '/',
  },
  system: {
    systemCode: 'EOS-QMP-CORE',
    logo: logo,
    faviconIco: logo,
    webTitle: getText('质量管理平台'),
    webSubTitle: '',
  },
  theme: {
    style: 'blue',
    layoutStyle: 'black-black',
    mode: 'light',
    leftBottomBgImg: bgLBBlueSrc,
    rightTopBgImg: '',
  },
  layout: {
    hiddenNewCodeTool: false,
    hiddenTopHeader: false,
    hiddenUserSettings: true,
    hiddenFavorites: false,
  },
  tabBar: {
    show: true,
    ignoreTabBarPersistent: true,
    scrollbar: {
      trigger: 'hover',
    },
    // showFeatureStatisticsAnalysis: false,
  },
  route: {
    baseOn: 'filesystem',
    baseURL: '/',
    homeTitle: getText('质量任务中心'),
    homePath: '/front/home',
    // 处理找不到路径的tab标题
    getNotFoundTabTitle(routes: RouteLocationNormalized) {
      const { path, query } = routes
      const waybillNo = query.waybillNo
      const matterpiceId = query.matterpiceId
      const examineType = query.examineType
      const isNeedAdd = IDROUTES_MAP.find(item => path.includes(item.path))
      // 是否需要自己添加tab的标题
      if ((window as any).$tabStore && !!isNeedAdd) {
        // 核查举证的标题特殊处理
        const title = getText(isNeedAdd.title || '')
        if (isNeedAdd.path === '/inspect_review/proof/' && examineType) {
          return `${EXAMIN_MAP[examineType as string]}(${matterpiceId || waybillNo})`
        } else if (title && (waybillNo || matterpiceId)) {
          return `${title}(${matterpiceId || waybillNo})`
        } else if (title) {
          return title
        }
      }
      return '404'
    }
  },
  basp: {
    baspSystemKey: systemkey,
    baspSubSystemCode: SYSTEM_CODE,
  },
  login: {
    type: 'cas',
  },
  language: {
    value: lang,
  },
  menu: {
    baseOn: 'basp',
    menuMode: 'head-side',
    orderType: 'ascending-order',
    favoritesDraggable: true,
    shouldRefreshMenuOnRoleListChange: true,
    async getMenus() {
      const res = await request({
        url: '/dev-basp-user/indexModule/queryMenus',
        method: 'get',
        params: {
          roleId: currentRole.value,
          time: Date.now(),
        },
      });
      const baspMenusFormat = (menus: any[], parentPath = '') => {
        if (!menus || menus.length === 0) return [];

        return menus
          .filter((item) => item.hidden !== 'Y')
          .map((item: any) => {
            const path = parentPath + '/' + item.moduleCode;
            // QMP菜单改版，需要添加头部的一级菜单，但不能影响原来的逻辑，需要对levelonly的菜单进行特殊处理
            const children: Array<any> = baspMenusFormat(item.childModules, path);
            let targetPath = `${BASE}${path}`;
            // 通过百源获取路由页面路径
            if (item.extendedAttributes) {
              try {
                const extendedAttributes = JSON.parse(item.extendedAttributes)
                targetPath = extendedAttributes.path ? `${BASE}${extendedAttributes.path}` : targetPath
              } catch (e) {
                console.log(e)
              }
            }
            // 分析页面做特殊处理
            if(['feature-statistics-analysis', 'system-statistics-analysis'].includes(item.moduleCode)) {
              targetPath = `/${item.moduleCode}?systemCode=${SYSTEM_CODE}`
            }
            return {
              path: targetPath,
              redirect: children.length ? children[0].path : undefined,
              id: item.moduleId,
              title: getText(item.moduleName),
              icon: item.moduleIcon,
              children,
              order: Number(item.sort),
              mouduleCode: item.moduleCode,
            };
          });
      };
      return { success: res.success, obj: [
        // {
        //   path: '/',
        //   title: '',
        //   children: [
            {
              path: '/',
              title: '品质工作台',
              id: 0,
              children: [
                {
                  path: '/front/home',
                  title: getText('质量任务中心'),
                  id: 0,
                  icon: 'home',
                },
              ]
            },
            ...baspMenusFormat(res?.obj),
          ],
        }
      // ] };
    },
    setActiveTopMenu: () => {},
    getFavorites: async () => {
      let favouriteList = []
      try {
        const res = await request({
          url: '/eos-qmp-core-base/compute/getCollectLove',
          method: 'get',
        });
        const { data } = res as any || {};
        favouriteList = data.favouriteList
      } catch (error) {
        console.log('获取收藏列表失败：', error);
      }
      return {
        success: true,
        obj: favouriteList,
      };
    },
    postFavorites: async (url: string, newArr: (string | number)[]) => {
      let res: any = {
        message: true
      }
      try {
        res = await request({
          url: '/eos-qmp-core-base/compute/updateCollectLove',
          method: 'post',
          data: {
            favouriteList: newArr
          }
        })
      } catch (error) {
        console.log('添加收藏列表失败：', error);
      }
      return {
        obj: newArr,
        success: res.message === 'success',
      };
    },
  },
  user: {
    async getUserInfo() {
      try {
        const host = window.location.host
        const isSit = host.includes('localhost') || host.includes('sit')
        const systemKey = isSit ? '5d9f1cfa7eeef20c6d84f022' : '5d9f143fbc7cf20c91f560e7'
        const roldId = sessionStorage.getItem('gw-bdus-rid')
        if (roldId) {
          const res = await request({ url: '/eos-qmp-core-base/system/currentemp', method: 'get', headers: { systemKey, 'gw-bdus-rid': roldId } });
          const { data = {} } = res as any;
          return {
            success: res.respCode === '0000',
            obj: {
              empCode: data?.empNum,
              empName: data?.empName,
              transitDepotNo: data?.deptCode,
              originUserInfo: data,
            }
          };
        }
        const res = await request({ url: '/apis-auth/login/check_token', method: 'get' });
        const { obj = {}, success } = res as any;
        return {
          success: success === true,
          obj: {
            empCode: obj?.userId,
            empName: obj?.userName,
            transitDepotNo: obj?.deptCode,
            originUserInfo: obj,
          }
        };
      } catch (e) {
        console.log(e)
      }
    }
  },
  role: {
    shouldCacheCurrentRole: true,
    async getRoles() {
      const res = await request({ url: '/dev-basp-user/indexModule/queryRoles', method: 'get' });
      const roles = sortRoles(res?.obj?.map((item: any) => ({
        ...item,
        roleName: getText(item.roleName)
      })));
      setRoles(roles);
      if (!sessionStorage.getItem('gw-bdus-rid')) {
        // 没有上次存起来的角色，则需要看看是否有默认角色，如果有则取默认角色，如果没有取第一个角色
        if (roles?.[0]?.roleId) {
          setCurrentRole(roles?.[0]?.roleId);
        }
      } else {
        setCurrentRole(sessionStorage.getItem('gw-bdus-rid') as string);
      }
      return { success: res.success, obj: res?.obj };
    },
  },
  errorConfig: {
    hideErrorAlert: false,
  },
  personalCenter: [
    {
      id: 'auth',
      placement: 'outside',
      comp: shallowRef(auth),
    },
    {
      id: 'center',
      label: '个人中心',
      type: 'button',
      icon: shallowRef(SDesignIconsVue.UserFilled),
      show: true,
      placement: 'personal-center-dropdown',
      jumpUrl: '/front/center',
    },
    {
      id: 'theme-mode',
      label: '模式',
      show: true,
      placement: 'personal-center-dropdown',
      type: 'select',
      props: {},
      optionsJson: JSON.stringify([
        { label: '浅色模式', value: 'light' },
        { label: '深色模式', value: 'dark' },
      ]),
    },
    { id: 'layoutStyle', label: '风格设置', show: true, placement: 'personal-center-dropdown' },
    // {
    //   id: 'back',
    //   label: '返回原版',
    //   show: true,
    //   onClick: () => {
    //     window.location.href = env === 'development' ? `http://localhost:9000` : '/webApp/front/home'
    //   },
    // },
    // {
    //   id: 'back',
    //   label: '我要反馈',
    //   show: true,
    //   icon: shallowRef(SDesignIconsVue.QuestionFilled),
    //   onClick: () => {
    //     window.open('https://fsdocs.sf-express.com/smartsheet/DQU1MZ3ZZenhBQmRkUExud2R1?tab=BB08J2&viewId=vUQPXH')
    //   },
    // },
    {
      id: 'ai-index',
      comp: PartToAI,
      show: true,
      placement: 'outside',
    },
    {
      id: 'lang',
      label: '',
      show: true,
      optionsJson: JSON.stringify([
        { label: '中文简体', value: 'zh_CN' },
        // { label: '中文繁體', value: 'zh_TW' },
        { label: 'English', value: 'en_US' },
      ]),
      onChange: (val: string) => {
        cookie('locale', val)
        localStorage.setItem('lang', val)
        sessionStorage.setItem('lang', val)
        window.location.reload()
      },
    },
    {
      id: 'logout',
      label: '退出登录',
      show: true,
      placement: 'personal-center-dropdown',
      type: 'button',
      props: {
        type: 'primary',
        plain: true,
      },
    },
  ],
  casConfig: {
    appKey: 'EOS-QMP-CORE',
    appSecret: 'qmp#2019',
    basePath: '',
    casDomain: '',
    serviceUrl: '',
  },
  sentryConfig: {
    dsn: isSit ? 'https://bedad9fb802e2444b61c591650a774ef@plan-fe-sentry.sit.sf-express.com/7' : 'https://c3de9e32d3f002a9c224f4d97a563e64@plan-fe-sentry.sf-express.com/17',
    initData: {
      integrations: [
        Sentry.browserTracingIntegration({ enableInp: true }),
        // Sentry.replayIntegration({
        //   maskAllText: false,
        //   maskAllInputs: false,
        // }),
      ],
      tracesSampleRate: 0.5,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      ignoreErrors: [
        '账号异地登录，请重新登录',
        '账号信息异常，请重新登录',
        'A DOM element reference is required',
        "Failed to set the 'playbackRate' property on 'HTMLMediaElement': The provided double value is non-finite.",
        '[web-sdk-error]: login id is invalid',
        'ResizeObserver loop limit exceeded',
        'Request failed with status code 401',
        'Request failed with status code 403',
        'Request failed with status code 404',
        'Request failed with status code 504',
        'Non-Error promise rejection captured with keys: currentTarget, isTrusted, target, type',
        'Non-Error exception captured with keys: currentTarget, detail, isTrusted, target',
        'NotSupportedError: The element has no supported sources.',
        'NotSupportedError: Failed to load because no supported source was found.',
        'Network Error',
        'Request aborted',
        'A DOM element reference is required',
        'onLayoutChanged is not defined',
        'Non-Error promise rejection captured with value: undefined',
        "Cannot read properties of undefined (reading 'ciphertext')",
        '账号信息异常，请重新登录',
        '当前级联选项不存在',
        '账号异地登录，请重新登录',
        '网络错误',
        '[object Object]',
        'Failed to fetch',
        'Navigating to current location',
        'Loading chunk inspect_review failed.',
        'Event `Event` (type=error) captured as promise rejection',
        'AbortError: The play() request was interrupted',
        'UnhandledRejection: Non-Error promise rejection captured with value: undefined',
        'HTTP Client Error with status code: 403',
        'HTTP Client Error with status code: 500',
        'HTTP Client Error with status code: 504',
        'AbortError: The play() request was interrupted because video-only background media was paused to save power',
        'AbortError: The play() request was interrupted because the media was removed from the document',
        'AbortError: The play() request was interrupted by a call to pause()',
        'AbortError: The play() request was interrupted by a new load request',
        'AbortError: The play() request was interrupted because the media was removed from the document. https://goo.gl/LdLk22',
        'AbortError: The play() request was interrupted by a call to pause(). https://goo.gl/LdLk22',
        'AbortError: The play() request was interrupted because video-only background media was paused to save power. https://goo.gl/LdLk22',
        'AbortError: The play() request was interrupted by a new load request. https://goo.gl/LdLk22',
        'Large Render Blocking Asset',
        "Cannot read properties of undefined (reading 'message')",
        "Cannot read properties of undefined (reading 'includes')"
      ],
    },
    // profileData: {},
  },
  sensorsConfig: {
    initData: {
      server_url: () => isSit ? undefined : 'https://ubs.sf-express.com/sa?project=snfl',
      show_log: false,
    },
    platform_type: 'Web',
    platform_name: 'OWF_PC',
    system_code: 'EOS-QMP-CORE',
    product_name: '质量管理平台',
  },
  feedbackConfig: {
    show: false,
  },
  subApps: [
    {
      name: 'QMP',
      entry: env === 'development' ? `http://localhost:9000` : '/webApp',
      // entry: 'http://qmp.sit.sf-express.com',
      preLoad: false,
      wujieConfigs: {
        isSingleMode: true,
      },
      keepAlive: true,
      isVite: false,
      dependentFramework: 'wujie',
      qiankunConfigs: {
        excludeAssetFilter(assetUrl: string) {
          return assetUrl.includes('freight.sf-express.com');
        },
      },
      routerSync: {
        onSubAppChange: (type, data, unused, url: string) => {
          if (!url) {
            return;
          }

          const { search } = new URL(url, window.location.origin)

          const params = new URLSearchParams(search);
          const query: { [key: string]: string } = {};
          params.forEach((value, key) => {
            query[key] = value;
          });
          delete query.noframe
          router.push({
            path: url,
            query,
          });
        },
        onMainAppChange() {
          const { pathname, search, hash, href } = window.location;
          // 路由处理
          if (search.includes('feedback=1')) return;

          const searchMap = new URLSearchParams(search);
          if (searchMap.get('noframe') !== '1') {
            // 隐藏侧边栏及 header
            searchMap.append('noframe', '1');
          }
          return {
            search: `?${searchMap.toString()}`,
            pathname: pathname.replace(BASE, ''),
            hash: '',
          };
        },
      },
    },
  ],
};

export default settings;
